module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/email-contact/email-contact.component.scss
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/email-contact/email-contact.component.scss
// module chunks = main